export default {
	api: {
		operationSuccess: '操作成功',
		operationFailed: '操作失敗',
		errorTip: '錯誤提示',
		successTip: '成功提示',
		errorMessage: '操作失敗,系統異常!',
		timeoutMessage: '登錄超時,請重新登錄!',
		apiTimeoutMessage: '介面請求超時,請刷新頁面重試!',
		apiRequestFailed: '請求出錯，請稍候重試',
		networkException: '網路異常',
		networkExceptionMsg: '網路異常，請檢查您的網路連接是否正常!',

		errMsg401: '用戶沒有許可權（令牌、用戶名、密碼錯誤）!',
		errMsg403: '用戶得到授權，但是訪問是被禁止的。!',
		errMsg404: '網路請求錯誤,未找到該資源!',
		errMsg405: '網路請求錯誤,請求方法未允許!',
		errMsg408: '網路請求超時!',
		errMsg500: '伺服器錯誤,請聯繫管理員!',
		errMsg501: '網路未實現!',
		errMsg502: '網路錯誤!',
		errMsg503: '服務不可用，伺服器暫時超載或維護!',
		errMsg504: '網路超時!',
		errMsg505: 'http版本不支持該請求!',
	},
	app: {
		logoutTip: '溫馨提醒',
		logoutMessage: '是否確認退出系統?',
		menuLoading: '菜單加載中...',
	},
	errorLog: {
		tableTitle: '錯誤日誌列表',
		tableColumnType: '類型',
		tableColumnDate: '時間',
		tableColumnFile: '檔',
		tableColumnMsg: '錯誤資訊',
		tableColumnStackMsg: 'stack資訊',

		tableActionDesc: '詳情',

		modalTitle: '錯誤詳情',

		fireVueError: '點擊觸發vue錯誤',
		fireResourceError: '點擊觸發資源加載錯誤',
		fireAjaxError: '點擊觸發ajax錯誤',

		enableMessage: '只在`/src/settings/projectSetting.ts` 內的useErrorHandle=true時生效.',
	},
	exception: {
		backLogin: '返回登錄',
		backHome: '返回首頁',
		subTitle403: '抱歉，您無權訪問此頁面。',
		subTitle404: '抱歉，您訪問的頁面不存在。',
		subTitle500: '抱歉，伺服器報告錯誤。',
		noDataTitle: '當前頁無數據',
		networkErrorTitle: '網路錯誤',
		networkErrorSubTitle: '抱歉，您的網路連接已斷開，請檢查您的網路！',
	},
	lock: {
		unlock: '點擊解鎖',
		alert: '鎖屏密碼錯誤',
		backToLogin: '返回登錄',
		entry: '進入系統',
		placeholder: '請輸入鎖屏密碼或者用戶密碼',
	},
	login: {
		backSignIn: '返回',
		signInFormTitle: '登錄',
		mobileSignInFormTitle: '手機登錄',
		qrSignInFormTitle: '二維碼登錄',
		signUpFormTitle: '註冊',
		forgetFormTitle: '重置密碼',

		signInTitle: '北極星後臺管理系統',
		signInDesc: '輸入您的個人詳細資訊開始使用！',
		policy: '我同意xxx隱私政策',
		scanSign: `掃碼後點擊"確認"，即可完成登錄`,

		loginButton: '登錄',
		registerButton: '註冊',
		rememberMe: '記住我',
		forgetPassword: '忘記密碼?',
		otherSignIn: '其他登錄方式',

		// notify
		loginSuccessTitle: '登錄成功',
		loginSuccessDesc: '哈嘍！歡迎使用北極星系統',

		// placeholder
		accountPlaceholder: '請輸入帳號',
		passwordPlaceholder: '請輸入密碼',
		smsPlaceholder: '請輸入驗證碼',
		mobilePlaceholder: '請輸入手機號碼',
		policyPlaceholder: '勾選後才能註冊',
		diffPwd: '兩次輸入密碼不一致',

		userName: '帳號',
		password: '密碼',
		confirmPassword: '確認密碼',
		email: '郵箱',
		smsCode: '短信驗證碼',
		mobile: '手機號碼',
	},
	yuanMiMa: '原密碼',
	xinMiMa: '新密碼',
	queRenMiMa: '確認密碼',
	xiuGaiYongHuMiMa: '修改用戶當前密碼',
	xiTongGuanLi: '系統管理',
	yunYingYongHuGuanLi: '運營用戶管理',
	keHuYongHuGuanLi: '客戶用戶管理',
	souSuoNeiRong: '搜索內容',
	yongHuZhangHao: '用戶賬號',
	yongHuXingMing: '用戶姓名',
	qingshuruyongHuXingMing: '請輸入用戶姓名',
	qingshuruyonghuzhanghao: '請輸入用戶帳號',
	qingshuruyonghushoujihao: '請輸入用戶手機號',
	qingshuruyonghuzhaungtai: '请選擇用戶狀態',
	lianXiDianHua: '聯絡電話',
	yongHuZhuangTai: '用戶狀態',
	zuiHouDengLuShiJian: '最後登錄時間',
	zaiZhi: '在職',
	liZhi: '離職',
	xingBie: '性別',
	nan: '男',
	nv: '女',
	tiShi: '提示',
	xuHao: '序號',
	fuzhi: '複製',
	queDingLizhi: '確定設定該用戶離職嗎',
	queDingZaiZhi: '確定設定該用戶在職嗎',
	queDingDelete: '確定刪除該客戶麼',
	queDingQiyong: '確定啟用該客戶麼',
	keHujiancheng: '客戶簡稱',
	zhuangTai: '狀態',
	constract: '聯繫人號碼',
	managerNumber: '管理員帳號',
	chongZhiMiMa: '重置密碼',
	quedingyaofuzhigaiyonghuma: '確定複製該用戶嗎?',
	quedingyaobianjigaiyonghuma: '確定編輯該用戶嗎?',
	quedingyaoxinzenggaiyonghuma: '確定新增該用戶嗎?',
	denglu: '登錄',
	workbench: '工作臺',
	analysis: '分析頁',
	dashboard: 'Dashboard',
	wushuju: '無數據',
	xianggang: '香港',
	zhongguo: '中國'
};
